module.exports = __webpack_public_path__ + "img/andorra.823d1d9.webp";